import React from "react";
import "./styles.scss";
function SaleMessage() {
  return (
    <div className="saleMessage-Row1 mt-4 mx-2 mx-md-0">
      <h6>
        PayDay Sale is LIVE ⚡ Unlock Massive Discounts on your wishlist💵. Shop now
      </h6>
    </div>
  );
}

export default SaleMessage;
